(function () {
  'use strict';

  var controllerKey = '__rwCustomerAccountController';
  if (window[controllerKey]) return;

  var root = document.querySelector('[data-rw-account-root]');
  if (!root || root.dataset.apiClientInitialized === 'true') return;
  root.dataset.apiClientInitialized = 'true';

  var apiBase = root.dataset.apiBase;
  var dialog = root.querySelector('[data-rw-account-dialog]');
  var statusNode = root.querySelector('[data-rw-account-status]');
  var phoneForm = root.querySelector('[data-rw-account-phone-form]');
  var codeForm = root.querySelector('[data-rw-account-code-form]');
  var nameInput = root.querySelector('#rw-account-full-name');
  var phoneInput = root.querySelector('#rw-account-phone');
  var codeInput = root.querySelector('#rw-account-code');
  var resendButton = root.querySelector('[data-rw-account-resend]');
  var resendTimer = 0;
  var state = {
    authenticated: false,
    sessionChecked: false,
    customer: null,
    challengeId: '',
    phone: '',
    fullName: '',
    resendAfter: 0,
    busy: false
  };

  function label(name) {
    return root.dataset[name] || '';
  }

  function request(path, options) {
    var settings = options || {};
    settings.credentials = 'include';
    settings.cache = 'no-store';
    settings.headers = Object.assign({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, settings.headers || {});

    return fetch(apiBase + path, settings).then(function (response) {
      return response.text().then(function (body) {
        var payload = null;
        try { payload = body ? JSON.parse(body) : {}; } catch (error) { payload = null; }
        return { response: response, payload: payload };
      });
    });
  }

  function normalizePhone(value) {
    var digits = window.RwadyInputUtils.normalizeDigits(value).replace(/[^0-9]/g, '');
    if (digits.indexOf('00964') === 0) digits = '0' + digits.slice(5);
    else if (digits.indexOf('964') === 0) digits = '0' + digits.slice(3);
    return /^07[0-9]{9}$/.test(digits) ? digits : '';
  }

  function setStatus(message, success) {
    statusNode.textContent = message || '';
    statusNode.classList.toggle('is-success', Boolean(success));
  }

  function showView(name) {
    root.querySelectorAll('[data-rw-account-view]').forEach(function (view) {
      view.hidden = view.dataset.rwAccountView !== name;
    });
    setStatus('');
  }

  function openDialog(view) {
    showView(view || (state.authenticated ? 'account' : 'phone'));
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else dialog.setAttribute('open', '');
  }

  function closeDialog() {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function customerName(customer) {
    if (!customer) return '';
    return String(customer.full_name || customer.first_name || '').trim();
  }

  function publishSession() {
    var detail = {
      authenticated: state.authenticated,
      checked: state.sessionChecked,
      customer: state.customer
    };
    document.documentElement.classList.toggle('rw-account-authenticated', state.authenticated);
    document.documentElement.classList.add('rw-account-session-ready');
    document.dispatchEvent(new CustomEvent('rw:account-session', { detail: detail }));

    var name = customerName(state.customer);
    var initial = window.RwadyInputUtils.firstLetter(name, 'R');
    root.querySelector('[data-rw-account-welcome]').textContent = name || label('accountLabel');
    document.querySelectorAll('[data-rw-account-greeting]').forEach(function (node) {
      var fallback = node.dataset.fallback || label('accountLabel');
      node.textContent = state.authenticated && name ? name : fallback;
    });
    document.querySelectorAll('[data-rw-account-avatar]').forEach(function (node) {
      node.textContent = initial;
      node.setAttribute('aria-label', name || label('accountLabel'));
    });
    document.querySelectorAll('[data-rw-account-auth-only]').forEach(function (node) {
      node.hidden = !state.authenticated;
    });
    document.querySelectorAll('[data-rw-account-guest-only]').forEach(function (node) {
      node.hidden = state.authenticated;
    });
    document.querySelectorAll('[data-rw-header-account]').forEach(function (node) {
      node.classList.toggle('rw-header-account--guest', !state.authenticated);
    });
  }

  function loadProfile() {
    if (!state.authenticated) return Promise.resolve(null);
    return request('/account/profile').then(function (result) {
      if (result.response.status === 401) {
        setSession(false, null);
        return null;
      }
      if (!result.response.ok || !result.payload) throw new Error('PROFILE_UNAVAILABLE');
      state.customer = result.payload.profile || result.payload.customer || result.payload;
      publishSession();
      return state.customer;
    }).catch(function () {
      setStatus(label('serviceError'));
      return null;
    });
  }

  function openFromTrigger() {
    openDialog(state.authenticated ? 'account' : 'phone');
    if (state.authenticated) loadProfile();
  }

  function setSession(authenticated, customer) {
    state.authenticated = Boolean(authenticated);
    state.customer = state.authenticated ? (customer || {}) : null;
    state.sessionChecked = true;
    publishSession();
  }

  function checkSession() {
    return request('/account/session').then(function (result) {
      if (!result.response.ok || !result.payload) throw new Error('SESSION_UNAVAILABLE');
      setSession(result.payload.authenticated === true, result.payload.customer || null);
      return state.authenticated;
    }).catch(function () {
      setSession(false, null);
      return false;
    });
  }

  function errorMessage(result, stage) {
    var status = result && result.response ? result.response.status : 0;
    if (status === 429) return label('tooManyAttempts');
    if (stage === 'send' && (status === 400 || status === 422)) return label('invalidPhone');
    if (stage === 'verify' && status === 410) return label('codeExpired');
    if (stage === 'verify' && (status === 400 || status === 401 || status === 403 || status === 422)) return label('codeFailed');
    return label('serviceError');
  }

  function updateResendButton() {
    window.clearTimeout(resendTimer);
    var seconds = Math.max(0, Math.ceil((state.resendAfter - Date.now()) / 1000));
    resendButton.disabled = state.busy || seconds > 0;
    resendButton.textContent = seconds > 0 ? label('resendInLabel') + ' ' + String(seconds) : label('resendLabel');
    if (seconds > 0) resendTimer = window.setTimeout(updateResendButton, 1000);
  }

  function sendChallenge(isResend) {
    if (state.busy) return Promise.resolve(false);
    var phone = normalizePhone(isResend ? state.phone : phoneInput.value);
    var fullName = String(isResend ? state.fullName : nameInput.value || '').trim();
    if (!phone) {
      setStatus(label('invalidPhone'));
      phoneInput.focus();
      return Promise.resolve(false);
    }

    state.busy = true;
    var button = isResend ? resendButton : phoneForm.querySelector('[data-rw-account-send]');
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = label('sendingLabel');
    setStatus('');

    var body = { phone: phone };
    if (fullName) body.full_name = fullName;
    return request('/account/auth/send', { method: 'POST', body: JSON.stringify(body) }).then(function (result) {
      if (!result.response.ok || !result.payload || !result.payload.challenge_id) {
        setStatus(errorMessage(result, 'send'));
        return false;
      }
      state.phone = phone;
      state.fullName = fullName;
      state.challengeId = String(result.payload.challenge_id);
      state.resendAfter = Date.now() + (Number(result.payload.resend_after) || 60) * 1000;
      showView('code');
      setStatus(label('codeSent'), true);
      codeInput.focus();
      return true;
    }).catch(function () {
      setStatus(label('serviceError'));
      return false;
    }).finally(function () {
      state.busy = false;
      button.disabled = false;
      button.textContent = originalText;
      updateResendButton();
    });
  }

  phoneForm.addEventListener('submit', function (event) {
    event.preventDefault();
    sendChallenge(false);
  });

  codeForm.addEventListener('submit', function (event) {
    event.preventDefault();
    if (state.busy) return;
    var code = window.RwadyInputUtils.normalizeOtpInput(codeInput.value, 6);
    codeInput.value = code;
    if (!/^[0-9]{6}$/.test(code)) {
      setStatus(label('invalidCode'));
      codeInput.focus();
      return;
    }

    state.busy = true;
    var button = codeForm.querySelector('[data-rw-account-verify]');
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = label('verifyingLabel');
    setStatus('');
    var body = { phone: state.phone, challenge_id: state.challengeId, code: code };
    if (state.fullName) body.full_name = state.fullName;

    request('/account/auth/verify', { method: 'POST', body: JSON.stringify(body) }).then(function (result) {
      if (!result.response.ok) {
        setStatus(errorMessage(result, 'verify'));
        return false;
      }
      return checkSession().then(function (authenticated) {
        if (!authenticated) {
          setStatus(label('serviceError'));
          return false;
        }
        closeDialog();
        return true;
      });
    }).catch(function () {
      setStatus(label('serviceError'));
    }).finally(function () {
      state.busy = false;
      button.disabled = false;
      button.textContent = originalText;
    });
  });

  resendButton.addEventListener('click', function () {
    if (Date.now() < state.resendAfter) return;
    sendChallenge(true);
  });

  root.querySelector('[data-rw-account-change-phone]').addEventListener('click', function () {
    state.challengeId = '';
    state.phone = '';
    state.fullName = '';
    state.resendAfter = 0;
    codeInput.value = '';
    showView('phone');
    updateResendButton();
    phoneInput.focus();
  });

  function logout() {
    if (state.busy) return;
    state.busy = true;
    request('/account/logout', { method: 'POST', body: '{}' }).then(function (result) {
      if (!result.response.ok) throw new Error('LOGOUT_FAILED');
      setSession(false, null);
      closeDialog();
    }).catch(function () {
      openDialog('account');
      setStatus(label('serviceError'));
    }).finally(function () {
      state.busy = false;
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-rw-customer-account-trigger]');
    if (trigger) {
      event.preventDefault();
      openFromTrigger();
      return;
    }
    if (event.target.closest('[data-rw-account-logout]')) {
      event.preventDefault();
      logout();
    }
  });

  root.querySelector('[data-rw-account-close]').addEventListener('click', closeDialog);
  dialog.addEventListener('click', function (event) {
    if (event.target === dialog) closeDialog();
  });

  window[controllerKey] = window.RwadyAccount = {
    checkSession: checkSession,
    open: openFromTrigger,
    loadProfile: loadProfile,
    logout: logout,
    getState: function () { return Object.assign({}, state); }
  };
  checkSession();
}());
